<template>
	<div class="tabWrapper homeInfo">
		<div class="main">
			<div class="itemInformation photo">
				<div class="photoWrap">

					<christmas-garland v-if="$inWindow(DATE.WINTER)"/>

					<template v-if="$inWindow(DATE.HALLOWEEN)">
						<img v-if="logoMod.url && isErrorFile || isUpdateAvatar" :src="logoMod.url" :alt="modName" @error="onError"  width="120" height="120">
						<svg-sprite v-else width="120" height="120" icon-id="pumpkin-halloween" halloween></svg-sprite>
					</template>
					<template v-else>
						<img v-if="logoMod.url && isErrorFile || isUpdateAvatar" :src="logoMod.url" :alt="modName" @error="onError"  width="120" height="120">
						<svg-sprite v-else width="120" height="120" icon-id="user"></svg-sprite>
					</template>

					<div v-if="$inWindow(DATE.HALLOWEEN)">
						<bat-h-t-m-l/>
					</div>
					<div v-if="!isUpdateAvatar" class="photoBtn photoZoom" @click="onPhotoZoom(logoMod.url)">
						<tool-tip
								text="Zoom Photo"
								content-class="top"
								custom-class="question"
								:position="{ top: 'top' }"
						>
							<svg-sprite icon-id="icon-zoom-in" width="20" height="20"></svg-sprite>
						</tool-tip>
					</div>
					<div class="photoBtn photoEdit" @click="toggleShow">
						<tool-tip
								text="Set new avatar"
								content-class="right"
								custom-class="question"
								:position="{ right: 'right' }"
						>
							<svg-sprite icon-id="edit" width="20" height="20"></svg-sprite>
						</tool-tip>
					</div>
					<div v-if="getIconId" class="iconCompany">
						<svg-sprite :icon-id="getIconId" width="20px" height="20px"></svg-sprite>
					</div>

				</div>
				<item-info-row
						icon-id="crown"
						:is-item-text="false"
						:is-item-dashed="false"
						:value="modName"
						is-big-value
						is-flex-start
						custom-class="userName"
				></item-info-row>
				<custom-btn
						text="Edit password"
						custom-class="apply extended"
						margin="0"
						@updateEvent="onOpenEditPassword"
				></custom-btn>
			</div>
			<div class="itemInformation userGeneralInfoWrapper">
				<div class="section">
					<div class="rowWrap">
						<item-info-row
								icon-id="crown"
								:is-item-text="false"
								:is-item-dashed="false"
								:value="modName"
								is-big-value
								is-flex-start
								custom-class="userName"
						></item-info-row>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="mapPin"
								text="Location:"
								:value="getLocation()"
						></item-info-row>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="department"
								text="Department:"
								:value="department"
						></item-info-row>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="directory"
								text="Position:"
								:value="position"
						></item-info-row>
						<tool-tip-question
								v-if="!position"
								text="The start date of work is not specified."
						></tool-tip-question>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="partyHorn"
								text="Start working date:"
								:value="start_working_date"
								:is-item-value="!!start_working_date"
						></item-info-row>
						<tool-tip-question
								v-if="!start_working_date"
								text="The start date of work is not specified."
						></tool-tip-question>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="bat"
								text="Worked:"
								:value="time_worked"
						></item-info-row>
						<tool-tip-question
								v-if="!start_working_date"
								text="The start date of work is not specified."
						></tool-tip-question>
					</div>
					<div class="rowWrap">
						<item-info-row
								icon-id="MoneyReceive"
								text="Balance:"
								:value="balance"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
								:is-item-value="!!balance"
						></item-info-row>
						<tool-tip-question
								v-if="!balance"
								text="There is no balance"
						></tool-tip-question>
					</div>
				</div>
			</div>
			<div class="itemInformation timeWrapper">
				<div class="section">
					<item-info-row
							icon-id="statistics-chart-graph"
							:is-item-text="false"
							:is-item-dashed="false"
							value="Work time"
							is-big-value
							is-flex-start
					></item-info-row>
					<div class="timeInfoWrap">
						<tool-tip
								text="Need to work time"
								content-class="top"
								custom-class="question"
								:position="{ top: 'top' }"
						>
							<item-info-row
									icon-id="TimeAdd"
									:is-item-text="false"
									:is-item-dashed="false"
									:value="timeLeft"
									is-flex-start
									custom-class="iconColorYellow"
							></item-info-row>
						</tool-tip>
						<tool-tip
								text="Worked time"
								content-class="top"
								custom-class="question"
								:position="{ top: 'top' }"
						>
							<item-info-row
									icon-id="TimeCheck"
									:is-item-text="false"
									:is-item-dashed="false"
									:value="workTimeMod"
									is-flex-start
							></item-info-row>
						</tool-tip>
						<tool-tip
								text="Total time"
								content-class="top"
								custom-class="question"
								:position="{ top: 'top' }"
						>
							<item-info-row
									icon-id="TimeFast"
									:is-item-text="false"
									:is-item-dashed="false"
									:value="allTime"
									is-flex-start
									custom-class="iconColorGrey"
							></item-info-row>
						</tool-tip>
					</div>
					<div class="timeWorkWrap">
						<div class="lineWrap">
							<div class="timeLine allTime"></div>
							<div class="timeLine workTime" :style="{ width: getwWidthPercentage + '%' }"></div>
							<tool-tip
									:text="getwWidthPercentageText"
									content-class="bottom"
									custom-class="question"
									:position="{ bottom: 'bottom' }"
							>
								<div class="timeLine filter">
									<div class="item"></div>
									<div class="item"></div>
									<div class="item"></div>
									<div class="item"></div>
								</div>
							</tool-tip>
						</div>
					</div>
					<item-info-row
							v-if="overtimeData"
							icon-id="TimeForward"
							text="Overtime:"
							:value="overtimeData"
							is-value-icon
							value-icon="icon-hour"
							value-icon-width="8px"
							value-icon-height="16px"
					></item-info-row>
				</div>
				<div class="section" v-if="show_check_button">
					<item-info-row
							icon-id="FingerprintAlt"
							:is-item-text="false"
							:is-item-dashed="false"
							value="Online authorization"
							is-big-value
							is-flex-start
					></item-info-row>

					<div class="btnWrapAuthorization">
						<custom-btn
								text="Check in"
								@updateEvent="isValidCheck(1)"
								custom-class="apply"
								is-all-elements
								is-extended
								margin="0"
								:icon-attrs="{width: 20, height: 20, iconId: 'ArrowRightToArc'}"
						/>
						<custom-btn
								text="Check out"
								@updateEvent="isValidCheck(2)"
								custom-class="danger"
								is-all-elements
								is-extended
								margin="0"
								:icon-attrs="{width: 20, height: 20, iconId: 'ArrowRightFromArc'}"
						/>
						<div v-if="$inWindow(DATE.HALLOWEEN)" class="halloween-zone">
							<balloon-halloween/>
						</div>
						<div v-if="$inWindow(DATE.HALLOWEEN)" class="halloween-head">
							<hand-halloween/>
						</div>
					</div>

				</div>
			</div>
			<div class="itemInformation salaryWrapper">
				<div class="section">
					<item-info-row
							icon-id="dollar-sign"
							:is-item-text="false"
							:is-item-dashed="false"
							value="Salary Information"
							is-big-value
							is-flex-start
					></item-info-row>
					<div class="rowWrap" v-if="salary || salary === 0">
						<item-info-row
								icon-id="CreditCard"
								text="Salary:"
								:value="salary"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="Total monthly"
							></tool-tip-question>
						</div>
					</div>
					<div class="rowWrap" v-if="bonus || bonus === 0">
						<item-info-row
								icon-id="CreditCardPlus"
								text="Bonus:"
								:value="bonus"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="The sum of all your bonuses for this period"
							></tool-tip-question>
						</div>
					</div>
					<div class="rowWrap" v-if="charge || charge === 0">
						<item-info-row
								icon-id="CreditCardMinus"
								text="Charge:"
								:value="charge"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="The sum of all your fines for this period"
							></tool-tip-question>
						</div>
					</div>
					<div class="rowWrap" v-if="total || total === 0">
						<item-info-row
								icon-id="icon-total"
								text="Total:"
								:value="total"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="Total of all your bonuses, fines and salary for this period"
							></tool-tip-question>
						</div>
					</div>
					<div class="rowWrap" v-if="late || late === 0">
						<item-info-row
								icon-id="TriangleExclamation"
								text="Late:"
								:value="late"
								is-value-icon
								value-icon="icon-minute"
								value-icon-width="11"
								value-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="Total number of minutes late for this period"
							></tool-tip-question>

						</div>
					</div>
					<div class="rowWrap" v-if="undetected || undetected === 0">
						<item-info-row
								icon-id="CircleQuestion"
								text="Undetected:"
								:value="undetected"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
						<div class="btnWrapper">
							<tool-tip-question
									text="Total monthly salary with Bonus and Сharge"
							></tool-tip-question>
						</div>
					</div>
				</div>
			</div>
			<div class="itemInformation salaryFormulaWrapper" v-if="scf">
				<div class="section">
					<item-info-row
							icon-id="icon-Formula"
							:is-item-text="false"
							:is-item-dashed="false"
							value="Salary calculation formula"
							is-big-value
							is-flex-start
					></item-info-row>
					{{ scf }}
				</div>
			</div>
			<div class="itemInformation workTableWrapper">

				<christmas-garland2 v-if="$inWindow(DATE.WINTER)"/>

				<div class="workTableHead">
					<div class="dateListWrap">
						<field
								v-if="!isMonth"
								inputClass="dateList"
								borderRadius="4px"
								margin="0"
								@updateSelect="onSelect($event, 'dateListStart')"
								:autocompleteValue="dateListStart"
								:items="dateList"
								:isClearable="false"
								item-text="name"
								item-value="date"
								is-select
						></field>

						<field
								v-else
								margin="0"
								width="210px"
								type="text"
								placeholder="Enter month"
								@updateDate="onDate($event, 'month')"
								:dateValue="month"
								isNoTitle
								isDate
								:month-mod="monthMod"
								date-picker-type="month"
						></field>
					</div>
					<div class="workTableHeadInfo">Check-in and check-out times made via the website are based on Ukranian time</div>
					<custom-btn
							:is-disabled="isDuties()"
							text="Duties"
							@updateEvent="onViewDuties"
							custom-class="duties"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'icon-ListDuties'}"
					></custom-btn>
					<custom-btn
							text="Request vacation"
							@updateEvent="onRequestVacation"
							custom-class="apply vacation"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'Umbrella'}"
					></custom-btn>

					<div v-if="$inWindow(DATE.HALLOWEEN)">
						<pumpkin-wrap-halloween/>

						<div class="candle"><svg-sprite width="40" height="40" icon-id="candle" halloween></svg-sprite></div>
						<div class="cauldronWrap">
							<div class="cauldron"><svg-sprite width="40" height="40" icon-id="cauldron" halloween></svg-sprite></div>
							<div class="zombie-horror"><svg-sprite width="32" height="32" icon-id="zombie-horror" halloween></svg-sprite></div>
						</div>
					</div>
				</div>
				<div v-if="isMonthLocal === false" class="workTableMain" :class="{ halloween: $inWindow(DATE.HALLOWEEN) }">
					<week-wrap
							v-for="(week, index) in weeks"
							:key="index"
							:weekTitle="`Week #${index + 1}`"
							@updateEventIconBtn="onEventIconBtn"
							:weeks="week"
							:allTime="allTimeMod"
					></week-wrap>
				</div>
				<div v-else-if="isMonthLocal === true" class="workTableMainMonth" :class="{ halloween: $inWindow(DATE.HALLOWEEN) }">
					<month-wrap
							:list="calendarData"
							@updateEventIconBtn="onEventIconBtn"
					/>
				</div>
				<div v-else class="workTableMain skeleton"></div>
				<!--qqqq-->
				<!--				<work-statistics-->
				<!--						:list="calendarMonthData"-->
				<!--				/>-->
			</div>
		</div>
		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				:is-save="isDialogRemoveSave"
				:text-remove-close="textRemoveClose"
				:width="width"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
		<my-upload
				field="img"
				@crop-success="cropSuccess"
				@crop-upload-success="cropUploadSuccess"
				@crop-upload-fail="cropUploadFail"
				@src-file-set="srcFileSet"
				v-model="show"
				langType="en"
				:width="480"
				:height="480"
				:params="params"
				:headers="headers"
				img-format="png"
				noCircle
		></my-upload>
		<preview-doc
				v-if="linkPreviewDoc"
				@clear-link="clearLinkPreviewDoc"
				:link-doc="linkPreviewDoc"
				:file-name="fileName"
		></preview-doc>

		<preload v-if="preloader"></preload>
	</div>
</template>

<script>
import CustomBtn from "@/shared/CustomBtn/CustomBtn.vue";
// services
import { getAppUrl } from "@/services";
// import ToolTip from "@/shared/ToolTip/ToolTip.vue";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import ToolTipQuestion from "@/shared/ToolTipQuestion/ToolTipQuestion.vue";
import { mapActions, mapGetters } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
import WeekWrap from "@/pages/Account/Tabs/WeekWrap/WeekWrap.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import { TEXT, TITLE } from "@/pages/Account/constants";
import moment from "moment";
import myUpload from "vue-image-crop-upload/upload-2.vue";
import ToolTip from "@/shared/ToolTip/ToolTip.vue";
import PreviewDoc from "@/modules/invoices/preview.vue";
import ChristmasGarland from "@/shared/ChristmasGarland/ChristmasGarland.vue";
import ChristmasGarland2 from "@/shared/ChristmasGarland2/ChristmasGarland2.vue";
import { getCalculateTimeDifference } from "@/helper/getCalculateTimeDifference";
// import { getGeolocationStatus } from "@/helper/getGeolocationStatus";
import BatHTML from "@/components/Auth/HalloweenAuth/batHTML.vue";
import BalloonHalloween from "@/shared/Halloween/balloon-halloween.vue";
import HandHalloween from "@/shared/Halloween/hand-halloween.vue";
import { DATE } from "@/constants/date";
import PumpkinWrapHalloween from "@/shared/Halloween/pumpkinWrap-halloween.vue";
import MonthWrap from "@/pages/Account/Tabs/MonthWrap/MonthWrap.vue";
// import { getGeolocationAddress } from "@/helper/getGeolocationAddress";
// import { getCurrentPositionAddress } from "@/helper/getCurrentPositionAddress";
// import { getGeolocationAddress } from "@/helper/getGeolocationAddress"; // Путь к файлу хелпера
import { toMonthBool, getFormatYmToLongTitle } from "@/helper";
// import WorkStatistics from "@/shared/WorkStatistics/WorkStatistics.vue";

export default {
	name: "AccountTabHome",
	components: {
		// WorkStatistics,
		MonthWrap,
		PumpkinWrapHalloween,
		HandHalloween,
		BalloonHalloween,
		BatHTML,
		ChristmasGarland2,
		ChristmasGarland,
		PreviewDoc,
		ToolTip,
		myUpload,
		DialogRemove,
		WeekWrap,
		Preload,
		ToolTipQuestion,
		ItemInfoRow,
		// ToolTip,
		CustomBtn
	},

	computed: {
		...mapGetters([
			'duties',
			'userData',
			'managerData',
			'monthData',
			'calendarData',
			'calendarMonthData',
			'overtime',
			'total_schedule_time',
			'total_work_time',
			'month_calendar',
			'month_info',
			'profileImage',
		]),
		getwWidthPercentage() {
			return (this.workTime / this.allTime) * 100;
		},
		getwWidthPercentageText() {
			const percentage = ((this.workTime / this.allTime) * 100).toFixed(1);
			return `${ this.workTimeMod } hours worked (${ percentage }%)`;
		},
		getIconId() {
			if (this.company_id === 2) return 'icon-altex';
			if (this.company_id === 1) return 'icon-fleet';
			return null;
		},
	},

	data: () => ({
		DATE,
		isErrorFile: true,
		bonus: null,
		charge: null,
		salary: null,
		total: null,
		late: null,
		undetected: null,
		modName: null,
		isDialogRemove: false,
		isDialogRemoveSave: true,
		width: '340',
		textRemoveClose: 'NO',
		titleRemove: null,
		textRemove: null,
		flagRemove: null,

		timeLeft: null,
		allTime: null,
		workTime: null,
		allTimeMod: null,
		workTimeMod: null,
		dateListStart: null,
		dateList: null,

		balance: null,
		company_id: null,
		created_at: null,
		department: null,
		dispatch_id: null,
		division_id: null,
		email: null,
		id: null,
		name: null,
		office: null,
		location: null,
		password: null,
		position: null,
		role: null,
		show_check_button: null,
		start_working_date: null,
		time_worked: null,
		type: null,
		scf: null,
		isMonth: false,
		isMonthLocal: null,
		month: null,
		monthMod: null,
		updated_at: null,

		overtimeData: null,

		month_calendarData: null,
		weeks: [],
		show: false,
		params: {
			token: '123456798',
			name: 'avatar'
		},
		headers: {
			smail: '*_~'
		},
		imgDataUrl: '', // the datebase64 url of created image

		logoMod: {},
		isUpdateAvatar: false,

		linkPreviewDoc: null,
		fileName: null,
		geo: null,
		coordinates: null,
		preloader: false,

		// retryCount: 3, // Количество повторных попыток
		// delay: 3000, // Задержка перед повторной попыткой

		geoFallbackTimer: null,
		geoAttemptId: 0,
		geoSourceSelected: null,
		checkRequestProcessed: false,

		statusCheck: null,
		dutiesHTML: null,
		isGeoErrorWrap: false,
		ip: null,
	}),
	methods: {
		...mapActions([
			'getUser',
			'getUpdateCalendar',
			'getUserСheck',
			'onEditPassword',
			'onLogin',
			'setAlert',
		]),

		isDuties() {
			return this.duties && this.duties.length < 0;
		},

		onOpenEditPassword() {
			this.isEditPassword = true;
			this.$emit('updateOpenEditPassword');
		},

		onError() {
			this.isErrorFile = false;
		},

		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

		async onRemove() {
			if (this.flagRemove === 'CheckOut') {
				this.onCheckInOut(2);
			}
			this.onCloseRemove();
		},

		startIpFallback(attemptId) {
			if (attemptId !== this.geoAttemptId) {
				console.warn('[startIpFallback] Old attempt ignored');
				return;
			}

			if (this.checkRequestProcessed) {
				console.warn('[startIpFallback] Check request already processed');
				return;
			}

			if (this.geoSourceSelected === 'gps') {
				console.warn('[startIpFallback] GPS already received');
				return;
			}

			if (this.geoSourceSelected === 'ip') {
				console.warn('[startIpFallback] IP request already started');
				return;
			}

			clearTimeout(this.geoFallbackTimer);
			this.geoFallbackTimer = null;

			this.geoSourceSelected = 'ip';

			console.warn(
				'[startIpFallback] GPS was not received within 8 seconds. Using IP.'
			);

			this.getCoords(attemptId);
		},

		// получение адреса с включеннім урбаном this.fetchGeolocation();
		// fetchGeolocation(retries = this.retryCount) {
		// 	console.log('%c [  fetchGeolocation  ] ', 'color:#bada55', this.retryCount );
		// 	navigator.geolocation.getCurrentPosition(
		// 		(position) => {
		// 			const lat = position.coords.latitude;
		// 			const lon = position.coords.longitude;
		// 			this.ip = null;
		// 			this.coordinates = `${ lat },${ lon }`;
		// 			console.log(`Координати: ${ lat }, ${ lon }`);
		//
		// 			this.fetchAddress(lat, lon);
		// 		},
		// 		(error) => {
		// 			console.error("Помилка отримання GPS:", error.message);
		// 			console.error("Помилка отримання GPS code:", error.code);
		//
		// 			switch (error.code) {
		// 				case error.PERMISSION_DENIED:
		// 					console.warn("Користувач заборонив доступ до геолокації.");
		// 					break;
		// 				case error.POSITION_UNAVAILABLE:
		// 					console.warn("Дані про місцезнаходження недоступні.");
		// 					break;
		// 				case error.TIMEOUT:
		// 					console.warn("Час очікування вийшов.");
		// 					break;
		// 				default:
		// 					console.warn("Невідома помилка при отриманні геолокації.");
		// 			}
		//
		// 			if (retries > 0 && error.code === error.PERMISSION_DENIED) {
		// 				console.warn(`Повторна спроба через ${ this.delay / 1000 } сек... Залишилось спроб: ${ retries }`);
		// 				setTimeout(() => {
		// 					this.fetchGeolocation(retries - 1);
		// 				}, this.delay);
		// 				// } else if (retries > 0 && error.code === 2) {
		// 				// console.warn(`Повторна спроба через ${ this.delay / 100 } сек... Залишилось спроб: ${ retries }`);
		// 				// setTimeout(() => {
		// 				// 	this.fetchGeolocation(retries - 1);
		// 				// }, this.delay);
		// 			} else {
		//
		// 				console.error("Не вдалося отримати геолокацію.");
		// 				this.updateGeoAlert({ error });
		// 				this.getCoords();
		// 			}
		// 		},
		// 		{
		// 			// enableHighAccuracy: true
		// 			enableHighAccuracy: false,
		// 			timeout: 10000,
		// 			maximumAge: 60000,
		// 		}
		// 	);
		// },

		// fetchGeolocation() {
		// 	console.log('%c [ 1 fetchGeolocation start ] ', 'color:#bada55');
		//
		// 	if (!navigator.geolocation) {
		// 		console.warn('Geolocation API is not supported');
		//
		// 		this.getCoords();
		// 		return;
		// 	}
		//
		// 	navigator.geolocation.getCurrentPosition(
		// 		(position) => {
		// 			const lat = position.coords.latitude;
		// 			const lon = position.coords.longitude;
		//
		// 			this.ip = null;
		// 			this.coordinates = `${ lat },${ lon }`;
		//
		// 			console.log('[fetchGeolocation success]', {
		// 				lat,
		// 				lon,
		// 				accuracy: position.coords.accuracy,
		// 			});
		//
		// 			this.fetchAddress(lat, lon);
		// 		},
		// 		(error) => {
		// 			console.error('[fetchGeolocation error]', {
		// 				code: error.code,
		// 				message: error.message,
		// 			});
		//
		// 			switch (error.code) {
		// 				case error.PERMISSION_DENIED:
		// 					console.warn('User denied geolocation permission');
		// 					break;
		//
		// 				case error.POSITION_UNAVAILABLE:
		// 					console.warn('Geolocation position is unavailable');
		// 					break;
		//
		// 				case error.TIMEOUT:
		// 					console.warn('Geolocation request timed out');
		// 					break;
		//
		// 				default:
		// 					console.warn('Unknown geolocation error');
		// 			}
		//
		// 			this.updateGeoAlert({ error });
		//
		// 			/*
		// 				 * Если браузер не смог получить GPS-координаты,
		// 				 * пробуем определить местоположение по IP.
		// 				 */
		// 			this.getCoords();
		// 		},
		// 		{
		// 			enableHighAccuracy: false,
		// 			timeout: 10000,
		// 			maximumAge: 60000,
		// 		}
		// 	);
		// },

		fetchGeolocation(attemptId) {
			console.log(
				'%c [ fetchGeolocation start ] ',
				'color:#bada55',
				{ attemptId }
			);

			if (!navigator.geolocation) {
				console.warn('Geolocation API is not supported');

				this.startIpFallback(attemptId);
				return;
			}

			/*
			 * Запускаем таймер одновременно с GPS.
			 *
			 * Если GPS придёт раньше 8 секунд,
			 * таймер будет отменён и IP-запрос не выполнится.
			 */
			clearTimeout(this.geoFallbackTimer);

			this.geoFallbackTimer = setTimeout(() => {
				this.startIpFallback(attemptId);
			}, 8000);

			navigator.geolocation.getCurrentPosition(
				(position) => {
					if (attemptId !== this.geoAttemptId) {
						console.warn('[fetchGeolocation] Старый результат GPS проигнорирован');
						return;
					}

					if (this.checkRequestProcessed) {
						console.warn('[fetchGeolocation] Проверка уже обработана');
						return;
					}

					/*
						 * GPS пришёл раньше IP-ответа.
						 * Выбираем GPS как более точный источник.
						 */
					clearTimeout(this.geoFallbackTimer);
					this.geoFallbackTimer = null;

					this.geoSourceSelected = 'gps';

					const lat = position.coords.latitude;
					const lon = position.coords.longitude;

					this.ip = null;
					this.coordinates = `${ lat },${ lon }`;

					console.log('[fetchGeolocation success]', {
						lat,
						lon,
						accuracy: position.coords.accuracy,
					});

					this.fetchAddress(lat, lon, attemptId);
				},
				(error) => {
					if (attemptId !== this.geoAttemptId) {
						console.warn('[fetchGeolocation] Старая ошибка GPS проигнорирована');
						return;
					}

					if (this.checkRequestProcessed) {
						return;
					}

					if (this.geoSourceSelected === 'gps') {
						console.warn(
							'[fetchGeolocation] Ошибка проигнорирована, так как GPS уже получен'
						);
						return;
					}

					console.error('[fetchGeolocation error]', {
						code: error.code,
						message: error.message,
					});

					switch (error.code) {
						case error.PERMISSION_DENIED:
							console.warn(
								'Геолокация: доступ запрещен пользователем. Ожидание завершения 8-секундного таймера.'
							);
							break;

						case error.POSITION_UNAVAILABLE:
							console.warn(
								'Геолокация недоступна. Ожидание завершения 8-секундного таймера.'
							);
							break;

						case error.TIMEOUT:
							console.warn(
								'Превышено время ожидания геолокации браузера. Ожидание резервного таймера.'
							);
							break;

						default:
							console.warn(
								'Неизвестная ошибка геолокации. Ожидание резервного таймера.'
							);
					}

					this.updateGeoAlert({ error });

					/*
						 * Здесь намеренно НЕ вызываем getCoords().
						 *
						 * IP-запрос выполнит только geoFallbackTimer,
						 * если точные координаты не придут в течение 8 секунд.
						 */
				},
				{
					enableHighAccuracy: false,

					/*
						 * Внутренний timeout браузера делаем больше нашего таймера.
						 * Наш IP-fallback запустится через 8 секунд.
						 */
					timeout: 15000,
					maximumAge: 60000,
				}
			);
		},

		// fetchAddress(lat, lon) {
		// 	fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${ lat }&lon=${ lon }&zoom=18&addressdetails=1`)
		// 		.then(response => response.json())
		// 		.then(data => {
		// 			this.geo = data.display_name;
		// 			this.preloader = false;
		// 			console.log("[ Addr ]", this.geo);
		//
		// 			this.onCheck(this.statusCheck);
		// 		})
		// 		.catch(error => {
		// 			console.error("Помилка при зворотному геокодуванні:", error);
		// 			this.preloader = false;
		// 		});
		// },

		// async fetchAddress(lat, lon) {
		// 	const controller = new AbortController();
		//
		// 	const timeoutId = setTimeout(() => {
		// 		controller.abort();
		// 	}, 8000);
		//
		// 	try {
		// 		console.log('[fetchAddress start]', {
		// 			lat,
		// 			lon,
		// 		});
		//
		// 		const response = await fetch(
		// 			`https://nominatim.openstreetmap.org/reverse?format=json&lat=${ lat }&lon=${ lon }&zoom=18&addressdetails=1`,
		// 			{
		// 				signal: controller.signal,
		// 			}
		// 		);
		//
		// 		if (!response.ok) {
		// 			throw new Error(`Nominatim HTTP error: ${ response.status }`);
		// 		}
		//
		// 		const data = await response.json();
		//
		// 		this.geo = data.display_name || `[GPS coordinates] ${ lat }, ${ lon }`;
		//
		// 		console.log('[fetchAddress success]', this.geo);
		// 	} catch (error) {
		// 		console.error('[fetchAddress error]', error);
		//
		// 		/*
		// 		 * Адрес получить не удалось, но координаты уже есть.
		// 		 * Поэтому разрешаем пользователю сделать Check in/out.
		// 		 */
		// 		this.geo = `[GPS coordinates] ${ lat }, ${ lon }`;
		// 	} finally {
		// 		clearTimeout(timeoutId);
		//
		// 		/*
		// 		 * Этот вызов обязателен и при успешном запросе,
		// 		 * и при ошибке Nominatim.
		// 		 */
		// 		this.onCheck(this.statusCheck);
		// 	}
		// },

		async fetchAddress(lat, lon, attemptId) {
			const controller = new AbortController();

			const timeoutId = setTimeout(() => {
				controller.abort();
			}, 8000);

			try {
				console.log('[fetchAddress start]', {
					lat,
					lon,
					attemptId,
				});

				const response = await fetch(
					`https://nominatim.openstreetmap.org/reverse?format=json&lat=${ lat }&lon=${ lon }&zoom=18&addressdetails=1`,
					{
						signal: controller.signal,
					}
				);

				if (!response.ok) {
					throw new Error(`Nominatim HTTP error: ${ response.status }`);
				}

				const data = await response.json();

				if (
					attemptId !== this.geoAttemptId ||
						this.geoSourceSelected !== 'gps' ||
						this.checkRequestProcessed
				) {
					console.warn('[fetchAddress] Old address result ignored');
					return;
				}

				this.geo =
						data.display_name ||
						`[GPS coordinates] ${ lat }, ${ lon }`;

				console.log('[fetchAddress success]', this.geo);
			} catch (error) {
				if (
					attemptId !== this.geoAttemptId ||
						this.geoSourceSelected !== 'gps' ||
						this.checkRequestProcessed
				) {
					return;
				}

				console.error('[fetchAddress error]', error);

				/*
				 * Координаты уже получены.
				 * Отсутствие текстового адреса не блокирует Check in.
				 */
				this.geo = `[GPS coordinates] ${ lat }, ${ lon }`;
			} finally {
				clearTimeout(timeoutId);

				if (
					attemptId === this.geoAttemptId &&
						this.geoSourceSelected === 'gps' &&
						!this.checkRequestProcessed
				) {
					this.onCheck(this.statusCheck);
				}
			}
		},

		// получение адреса с включеннім урбаном this.fetchGeolocation();

		// getCoords() {
		// 	return new Promise((resolve) => {
		// 		navigator.geolocation.getCurrentPosition(
		// 			(pos) => {
		// 				resolve({
		// 					status: true,
		// 					method: 'geolocation',
		// 					coords: pos.coords
		// 				});
		// 			},
		//
		// 			() => {
		// 				fetch("https://ipwho.is/")
		// 					.then(res => res.json())
		// 					.then(data => {
		// 						const { country, region, city, connection, latitude: lat, longitude: lon, ip } = data;
		//
		// 						if (!lat || !lon) {
		// 							this.getCoords2();
		// 							console.warn('⚠️ Відсутні координати у відповіді від ipwho.is', data);
		// 							// resolve({ status: false, method: 'ipwho.is', error: 'Missing lat/lon' });
		// 							return;
		// 						}
		//
		// 						this.ip = ip;
		// 						this.geo = `[⚠️ IP-based coords] ${ country }, ${ region }, ${ city }, (Provider ${ connection?.isp || 'unknown' })`;
		// 						this.coordinates = `${ lat },${ lon }`;
		//
		// 						console.info('[📡 IP-based coords]', data);
		//
		// 						this.onCheck(this.statusCheck);
		// 						resolve({
		// 							status: true,
		// 							method: 'ipwho.is',
		// 							coords: { latitude: lat, longitude: lon }
		// 						});
		// 					})
		// 					.catch(err => {
		// 						this.getCoords2();
		// 						console.error('❌ Помилка запиту до ipwho.is:', err);
		// 						// resolve({ status: false, method: 'ipwho.is', error: err.message });
		// 					});
		// 			},
		// 			{
		// 				enableHighAccuracy: true,
		// 				timeout: 7000,
		// 				maximumAge: 0
		// 			}
		// 		);
		// 	});
		// },

		// async getCoords() {
		// 	const controller = new AbortController();
		//
		// 	const timeoutId = setTimeout(() => {
		// 		controller.abort();
		// 	}, 8000);
		//
		// 	try {
		// 		console.log('%c [ getCoords by ipwho.is ] ', 'color:#bada55');
		//
		// 		const response = await fetch('https://ipwho.is/', {
		// 			signal: controller.signal,
		// 		});
		//
		// 		if (!response.ok) {
		// 			throw new Error(`ipwho.is HTTP error: ${ response.status }`);
		// 		}
		//
		// 		const data = await response.json();
		//
		// 		const {
		// 			country,
		// 			region,
		// 			city,
		// 			connection,
		// 			latitude: lat,
		// 			longitude: lon,
		// 			ip,
		// 		} = data;
		//
		// 		if (!lat || !lon) {
		// 			throw new Error('ipwho.is did not return coordinates');
		// 		}
		//
		// 		this.ip = ip;
		// 		this.coordinates = `${ lat },${ lon }`;
		// 		this.geo = `[IP-based coordinates] ${ country }, ${ region }, ${ city }, Provider: ${ connection?.isp || 'unknown' }`;
		//
		// 		console.log('[getCoords success]', {
		// 			ip,
		// 			lat,
		// 			lon,
		// 			geo: this.geo,
		// 		});
		//
		// 		this.onCheck(this.statusCheck);
		// 	} catch (error) {
		// 		console.error('[getCoords error]', error);
		//
		// 		await this.getCoords2();
		// 	} finally {
		// 		clearTimeout(timeoutId);
		// 	}
		// },

		async getCoords(attemptId) {
			if (
				attemptId !== this.geoAttemptId ||
					this.geoSourceSelected !== 'ip' ||
					this.checkRequestProcessed
			) {
				console.warn('[getCoords] IP request skipped');
				return;
			}

			const controller = new AbortController();

			const timeoutId = setTimeout(() => {
				controller.abort();
			}, 8000);

			try {
				console.log(
					'%c [ getCoords by ipwho.is ] ',
					'color:#bada55',
					{ attemptId }
				);

				const response = await fetch('https://ipwho.is/', {
					signal: controller.signal,
				});

				if (!response.ok) {
					throw new Error(
						`ipwho.is HTTP error: ${ response.status }`
					);
				}

				const data = await response.json();

				/*
				 * Пока IP-сервис отвечал, мог появиться GPS.
				 * В таком случае IP-ответ не используем.
				 */
				if (
					attemptId !== this.geoAttemptId ||
						this.geoSourceSelected !== 'ip' ||
						this.checkRequestProcessed
				) {
					console.warn('[getCoords] Late IP result ignored');
					return;
				}

				const {
					country,
					region,
					city,
					connection,
					latitude: lat,
					longitude: lon,
					ip,
				} = data;

				if (!lat || !lon) {
					throw new Error(
						'ipwho.is did not return coordinates'
					);
				}

				this.ip = ip;
				this.coordinates = `${ lat },${ lon }`;
				this.geo = `[IP-based coordinates] ${ country }, ${ region }, ${ city }, Provider: ${ connection?.isp || 'unknown' }`;

				console.log('[getCoords success]', {
					ip,
					lat,
					lon,
					geo: this.geo,
				});

				this.onCheck(this.statusCheck);
			} catch (error) {
				if (
					attemptId !== this.geoAttemptId ||
						this.geoSourceSelected !== 'ip' ||
						this.checkRequestProcessed
				) {
					return;
				}

				console.error('[getCoords error]', error);

				await this.getCoords2(attemptId);
			} finally {
				clearTimeout(timeoutId);
			}
		},

		// getCoords2() {
		// 	console.log('%c [  getCoords2  ] ', 'color:#bada55' );
		// 	return new Promise((resolve) => {
		// 		navigator.geolocation.getCurrentPosition(
		// 			(pos) => {
		// 				resolve({
		// 					status: true,
		// 					method: 'geolocation',
		// 					coords: pos.coords
		// 				});
		// 			},
		//
		// 			() => {
		// 				fetch("https://api.ipwho.org/me")
		// 					.then(res => res.json())
		// 					.then(data => {
		// 						const { country, region, city, asn, latitude: lat, longitude: lon, ip } = data.data;
		//
		// 						if (!lat || !lon) {
		// 							console.warn('⚠️ Відсутні координати у відповіді від api.ipwho.org/me', data);
		// 							resolve({ status: false, method: 'api.ipwho.org/me', error: 'Missing lat/lon' });
		// 							return;
		// 						}
		//
		// 						this.ip = ip;
		// 						this.geo = `[⚠️ IP-based coords 2] ${ country }, ${ region }, ${ city }, (Provider ${ asn?.org || 'unknown' })`;
		// 						this.coordinates = `${ lat },${ lon }`;
		//
		// 						console.info('[📡 IP-based coords 2]', data);
		//
		// 						this.onCheck(this.statusCheck);
		// 						resolve({
		// 							status: true,
		// 							method: 'api.ipwho.org/me',
		// 							coords: { latitude: lat, longitude: lon }
		// 						});
		// 					})
		// 					.catch(err => {
		// 						console.error('❌ Помилка запиту до api.ipwho.org/me:', err);
		// 						resolve({ status: false, method: 'api.ipwho.org/me', error: err.message });
		// 					});
		// 			},
		// 			{
		// 				enableHighAccuracy: true,
		// 				timeout: 7000,
		// 				maximumAge: 0
		// 			}
		// 		);
		// 	});
		// },

		// async getCoords2() {
		// 	const controller = new AbortController();
		//
		// 	const timeoutId = setTimeout(() => {
		// 		controller.abort();
		// 	}, 8000);
		//
		// 	try {
		// 		console.log('%c [ getCoords2 by api.ipwho.org ] ', 'color:#bada55');
		//
		// 		const response = await fetch('https://api.ipwho.org/me', {
		// 			signal: controller.signal,
		// 		});
		//
		// 		if (!response.ok) {
		// 			throw new Error(`api.ipwho.org HTTP error: ${ response.status }`);
		// 		}
		//
		// 		const responseData = await response.json();
		// 		const data = responseData.data;
		//
		// 		if (!data) {
		// 			throw new Error('api.ipwho.org returned empty data');
		// 		}
		//
		// 		const {
		// 			country,
		// 			region,
		// 			city,
		// 			asn,
		// 			latitude: lat,
		// 			longitude: lon,
		// 			ip,
		// 		} = data;
		//
		// 		if (!lat || !lon) {
		// 			throw new Error('api.ipwho.org did not return coordinates');
		// 		}
		//
		// 		this.ip = ip;
		// 		this.coordinates = `${ lat },${ lon }`;
		// 		this.geo = `[IP-based coordinates 2] ${ country }, ${ region }, ${ city }, Provider: ${ asn?.org || 'unknown' }`;
		//
		// 		console.log('[getCoords2 success]', {
		// 			ip,
		// 			lat,
		// 			lon,
		// 			geo: this.geo,
		// 		});
		//
		// 		this.onCheck(this.statusCheck);
		// 	} catch (error) {
		// 		console.error('[getCoords2 error]', error);
		//
		// 		this.preloader = false;
		//
		// 		this.setAlert({
		// 			type: 'error',
		// 			message: 'Failed to determine your location. Check browser and Windows location permissions.',
		// 		});
		// 	} finally {
		// 		clearTimeout(timeoutId);
		// 	}
		// },

		async getCoords2(attemptId) {
			if (
				attemptId !== this.geoAttemptId ||
					this.geoSourceSelected !== 'ip' ||
					this.checkRequestProcessed
			) {
				console.warn('[getCoords2] Second IP request skipped');
				return;
			}

			const controller = new AbortController();

			const timeoutId = setTimeout(() => {
				controller.abort();
			}, 8000);

			try {
				console.log(
					'%c [ getCoords2 by api.ipwho.org ] ',
					'color:#bada55',
					{ attemptId }
				);

				const response = await fetch(
					'https://api.ipwho.org/me',
					{
						signal: controller.signal,
					}
				);

				if (!response.ok) {
					throw new Error(
						`api.ipwho.org HTTP error: ${ response.status }`
					);
				}

				const responseData = await response.json();
				const data = responseData.data;

				if (
					attemptId !== this.geoAttemptId ||
						this.geoSourceSelected !== 'ip' ||
						this.checkRequestProcessed
				) {
					console.warn('[getCoords2] Late IP result ignored');
					return;
				}

				if (!data) {
					throw new Error(
						'api.ipwho.org returned empty data'
					);
				}

				const {
					country,
					region,
					city,
					asn,
					latitude: lat,
					longitude: lon,
					ip,
				} = data;

				if (!lat || !lon) {
					throw new Error(
						'api.ipwho.org did not return coordinates'
					);
				}

				this.ip = ip;
				this.coordinates = `${ lat },${ lon }`;
				this.geo = `[IP-based coordinates 2] ${ country }, ${ region }, ${ city }, Provider: ${ asn?.org || 'unknown' }`;

				console.log('[getCoords2 success]', {
					ip,
					lat,
					lon,
					geo: this.geo,
				});

				this.onCheck(this.statusCheck);
			} catch (error) {
				if (
					attemptId !== this.geoAttemptId ||
						this.geoSourceSelected !== 'ip' ||
						this.checkRequestProcessed
				) {
					return;
				}

				console.error('[getCoords2 error]', error);

				this.preloader = false;

				this.setAlert({
					type: 'error',
					message: 'Failed to determine your location. Check browser and Windows location permissions.',
				});
			} finally {
				clearTimeout(timeoutId);
			}
		},

		updateGeoAlert({ error }) {
			console.log(navigator.platform);
			console.log(navigator.platform);
			console.log(navigator.userAgent);
			// this.setAlert({ type: "success", message: "Saving Successfully" });

			const platform = navigator.platform;
			const { code } = error;
			if (code === 2 && platform === 'MacIntel') {
				const title = `🔐 The browser does not have permission in macOS.`;
				const text = `
				<div class="geoInstructions">
				  <p>🛡️ <strong>Enable geolocation</strong> for your browser in macOS:</p>
				  <ol>
				    <li>Open <strong>System Settings</strong></li>
				    <li>Go to <strong>Privacy & Security → Location Services</strong></li>
				    <li>Turn on the toggle switch for <strong>Location Services</strong></li>
				    <li>Make sure there is a checkmark ✅ next to <strong>Chrome</strong>, <strong>Safari</strong>, or <strong>Brave</strong></li>
				  </ol>
				  <p>💡 If everything is already enabled but your location still can't be determined, your Internet provider or network may be blocking geolocation.</p>
				</div>
				`;
				this.onRemoveDialog({ title, text });
				this.isDialogRemoveSave = false;
				this.width = '540';
				this.textRemoveClose = 'Close';
			}
		},

		// async isValidCheck2(statusCheck) {
		// 	this.statusCheck = statusCheck;
		// 	this.preloader = true;
		//
		// 	// const status = true;
		// 	// const id = 10;
		// 	const { status, id, text } = await getGeolocationStatus();
		// 	this.geoErrorId = id;
		// 	console.info(id, status, text);
		//
		// 	if (!status && id === 2) {
		// 		this.isGeoErrorWrap = true;
		// 		this.geoErrorText = 'You have disabled location tracking. 📍❌';
		// 		this.setAlert({ type: "error", message: '❌ Geolocation is disabled. To check in/out remotely, you need to enable geolocation access.' });
		// 		this.preloader = false;
		// 	} else if (!status && id === 8) {
		// 		this.isGeoErrorWrap = true;
		// 		this.geoErrorText = 'The service cannot access your location data. 📍🚫';
		// 		this.setAlert({ type: "warning", message: '🚫 The service cannot access your location data. This might be blocked by one of your browser extensions, such as a VPN, an ad blocker, or something else. 🛑🔧' });
		//
		// 		this.preloader = false;
		// 	} else if (status) {
		// 		this.isGeoErrorWrap = false;
		// 		this.preloader = false;
		//
		// 		// this.onCheck(status);
		//
		// 		const rrr = new Promise((resolve) => {
		// 			navigator.geolocation.getCurrentPosition(
		// 				(position) => {
		// 					resolve({
		// 						status: true,
		// 						id: 6,
		// 						text: `✅ 1Користувач дозволив доступ до геоданих. Широта: ${ position.coords.latitude }, Довгота: ${ position.coords.longitude }`
		// 					});
		// 				},
		// 				(error) => {
		// 					if (error.code === error.PERMISSION_DENIED) {
		// 						resolve({
		// 							status: false,
		// 							id: 7,
		// 							text: "❌ 1Користувач відмовився від доступу до геоданих."
		// 						});
		// 					} else {
		// 						resolve({
		// 							status: false,
		// 							id: 8,
		// 							text: `‼️ 1Помилка при отриманні геоданих: ${ error.message } (Код: ${ error.code })`
		// 						});
		// 					}
		// 				}
		// 			);
		// 		});
		// 		console.log('%c [  rrr  ] ', 'color:#bada55', typeof rrr, rrr );
		//
		// 		console.info('%c [  this.getCoords()  ] ', 'color:#bada55', typeof this.getCoords(), this.getCoords() );
		//
		// 	} else {
		// 		this.preloader = false;
		// 		this.isGeoErrorWrap = true;
		// 		this.setAlert({ type: "warning", message: '🚫Geolocation is disabled. To check in/out remotely, you need to enable geolocation access.' });
		// 	}
		//
		// },

		// isValidCheck(status) {
		// 	console.log('%c [ isValidCheck status  ] ', 'color:#bada55', typeof status, status );
		// 	this.preloader = true;
		// 	this.statusCheck = status;
		// 	this.fetchGeolocation();
		// },

		// isValidCheck(status) {
		// 	console.log(
		// 		'%c [ isValidCheck status ] ',
		// 		'color:#bada55',
		// 		typeof status,
		// 		status
		// 	);
		//
		// 	this.preloader = true;
		// 	this.statusCheck = status;
		//
		// 	this.geo = null;
		// 	this.coordinates = null;
		// 	this.ip = null;
		//
		// 	this.fetchGeolocation();
		// },

		isValidCheck(status) {
			console.log(
				'%c [ isValidCheck status ] ',
				'color:#bada55',
				typeof status,
				status
			);

			/*
			 * Отменяем таймер от предыдущей попытки.
			 */
			clearTimeout(this.geoFallbackTimer);

			this.geoFallbackTimer = null;
			this.geoSourceSelected = null;
			this.checkRequestProcessed = false;

			/*
			 * Уникальный ID текущего нажатия.
			 * Старые ответы не смогут повлиять на новую попытку.
			 */
			this.geoAttemptId += 1;

			this.preloader = true;
			this.statusCheck = status;

			this.geo = null;
			this.coordinates = null;
			this.ip = null;

			this.fetchGeolocation(this.geoAttemptId);
		},

		// onCheck(status) {
		// 	this.preloader = false;
		//
		// 	if (status === 1) {
		// 		this.onCheckInOut(1);
		// 	} else {
		// 		this.flagRemove = 'CheckOut';
		// 		const title = TITLE.END_WORK;
		// 		const text = TEXT.END_WORK;
		// 		this.onRemoveDialog({ title, text });
		// 		this.isDialogRemoveSave = true;
		// 		this.width = '440';
		// 		this.textRemoveClose = 'NO';
		// 	}
		// },

		onCheck(status) {
			if (this.checkRequestProcessed) {
				console.warn('[onCheck] Duplicate request ignored');
				return;
			}

			this.checkRequestProcessed = true;

			clearTimeout(this.geoFallbackTimer);
			this.geoFallbackTimer = null;

			this.preloader = false;

			console.log('[onCheck]', {
				status,
				source: this.geoSourceSelected,
				geo: this.geo,
				coordinates: this.coordinates,
				ip: this.ip,
			});

			if (status === 1) {
				this.onCheckInOut(1);
			} else {
				this.flagRemove = 'CheckOut';

				const title = TITLE.END_WORK;
				const text = TEXT.END_WORK;

				this.onRemoveDialog({ title, text });

				this.isDialogRemoveSave = true;
				this.width = '440';
				this.textRemoveClose = 'NO';
			}
		},

		async onCheckInOut(status) {
			const geo = this.geo;
			const coordinates = this.coordinates;
			const ip = this.ip;
			await this.getUserСheck({ geo, status, coordinates, ip });
			this.onUpdateCalendar();
		},

		onSelect({ value }, key) {
			if (key === 'dateListStart') {
				this[key] = value;
				this.onUpdateCalendar();
			}
		},
		onDate(value, key) {
			if (key === 'month') {
				this.dateListStart.date = value + '-01';
				this.onUpdateCalendar();

				this.month = value;
				this.monthMod = getFormatYmToLongTitle(value);
			} else {
				this[key] = value;
			}
		},

		async onUpdateCalendar() {
			if (!this.dateListStart?.date) {
				console.warn('dateListStart is empty');
				return;
			}

			this.preloader = true;

			try {
				await this.getUpdateCalendar({
					date: this.dateListStart.date,
				});
			} finally {
				this.preloader = false;
			}
		},

		onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
		},
		onEventIconBtn(args) {
			const { dateListStart, id } = this.$data;
			const { date } = dateListStart;
			const { key, item } = args;
			const employee_id = id;

			this.$emit('updateCalendarEventIconBtn', { key, item, employee_id, date });
		},
		onViewDuties() {
			const duties = this.dutiesHTML;
			const department = this.department;

			this.$emit('updateViewDuties', { duties, department });
		},
		onRequestVacation(args) {
			this.$emit('updateRequestVacation', args);
		},
		// Функция для разделения массива
		onSplitArray(arr, chunkSize) {
			const result = [];
			for (let i = 0; i < arr.length; i += chunkSize) {
				result.push(arr.slice(i, i + chunkSize));
			}
			return result;
		},
		getLocation() {
			return `${ this.office } / ${ this.location }`;
		},
		getTimeMoment(decimalTime) {
			if (decimalTime % 1 !== 0) {
				// Получаем часы
				const hours = (Math.floor(decimalTime) > 9) ? Math.floor(decimalTime) : moment().hours(Math.floor(decimalTime)).format("HH");

				// Получаем десятичные минуты и переводим их в реальные минуты
				const decimalMinutes = decimalTime - hours;
				const minutes = moment().minutes(Math.round(decimalMinutes * 60)).format("mm");

				return `${ hours }:${ minutes }`;
			}

			return decimalTime;
		},
		calculateTimeDifference(totalTime, timeToSubtract) {
			return getCalculateTimeDifference(totalTime, timeToSubtract);
		},

		toggleShow() {
			this.show = !this.show;
		},

		srcFileSet(args) {
			this.logoMod.name = args;
		},

		// /**
		//  * crop success
		//  *
		//  * [param] imgDataUrl
		//  * [param] field
		//  */
		async cropSuccess(imgDataUrl) {
			console.log('-------- crop success --------');
			this.imgDataUrl = imgDataUrl;

			this.logoMod.url = imgDataUrl;
			this.logoMod.value = imgDataUrl;

			this.isUpdateAvatar = true;
			await this.onEditPassword({ logo: this.logoMod });
			// this.isUpdateAvatar = false;
		},
		// /**
		//  * upload success
		//  *
		//  * [param] jsonData  server api return data, already json encode
		//  * [param] field
		//  */
		cropUploadSuccess(jsonData, field) {
			console.log('-------- upload success --------');
			console.log(jsonData);
			console.log('field: ' + field);
		},
		// /**
		//  * upload fail
		//  *
		//  * [param] status    server api return error status, like 500
		//  * [param] field
		//  */
		cropUploadFail(status, field) {
			console.log('-------- upload fail --------');
			console.log(status);
			console.log('field: ' + field);
		},

		onPhotoZoom(args) {
			this.linkPreviewDoc = args;
			this.fileName = args.split('/').pop();
		},
		clearLinkPreviewDoc() {
			this.linkPreviewDoc = null;
		},
		updateMonthInfo(month_info) {
			const {
				bonus,
				charge,
				salary,
				total,
				late,
				undetected,
			} = month_info;

			this.bonus = !isNaN(bonus) ? Number(bonus).toFixed(2) : null;
			this.charge = !isNaN(charge) ? Number(charge).toFixed(2) : null;
			this.salary = !isNaN(salary) ? Number(salary).toFixed(2) : null;
			this.total = !isNaN(total) ? Number(total).toFixed(2) : null;
			this.late = !isNaN(late) ? Number(late).toFixed(2) : null;
			this.undetected = !isNaN(undetected) ? Number(undetected).toFixed(2) : null;
		},

		requestLocation() {
			this.preloader = true;
			navigator.geolocation.getCurrentPosition(
				() => {
					this.preloader = false;
					if (navigator.userAgent.includes("Firefox")) {
						if (!localStorage.getItem("geoFirefox")) {
							localStorage.setItem("geoFirefox", "1");
							location.reload();
						}
					}
				},
				() => {
					this.preloader = false;
				}
			);
		},
		getCurrentMonth() {
			const d = new Date();
			const m = String(d.getMonth() + 1).padStart(2, '0');
			return `${ d.getFullYear() }-${ m }`;
		},
	},

	async mounted() {

		// await this.requestLocation();

		await this.getUser();

		this.dutiesHTML = this.duties;

		const {
			balance,
			company_id,
			department,
			id,
			office,
			location,
			position,
			show_check_button,
			start_working_date,
			time_worked,
			type,
			scf,
			month,
		} = this.userData;

		this.balance = balance;
		this.company_id = company_id;
		this.department = department;
		this.id = id;
		this.name = this.userData.name;
		this.office = office;
		this.location = location;
		this.position = position;
		this.show_check_button = show_check_button;
		this.start_working_date = start_working_date;
		this.time_worked = time_worked;
		this.type = type;
		this.scf = scf;
		this.isMonth = toMonthBool(month);

		this.overtimeData = this.getTimeMoment(this.overtime);
		this.allTime = this.total_schedule_time;
		this.workTime = this.total_work_time;
		this.allTimeMod = this.getTimeMoment(this.total_schedule_time);
		this.workTimeMod = this.getTimeMoment(this.total_work_time);
		this.timeLeft = this.calculateTimeDifference(this.allTime, this.workTime);
		this.month_calendarData = this.month_calendar;

		// const dateListStart = this.monthData.filter(item => item.date === this.month_calendarData);
		// const { date, name } = dateListStart[0];
		// this.dateListStart = { date, name };

		const monthData = Array.isArray(this.monthData)
			? this.monthData.filter(item => item && item.date)
			: [];

		this.dateList = [ ...monthData ].reverse();

		const selectedDate = monthData.find(
			item => item.date === this.month_calendarData
		);

		if (selectedDate) {
			this.dateListStart = {
				date: selectedDate.date,
				name: selectedDate.name,
			};
		} else {
			this.dateListStart = null;

			console.warn('Calendar date was not found', {
				month_calendar: this.month_calendarData,
				monthData,
			});
		}

		if (month) {
			this.month = this.month_calendar.slice(0, -3);
			this.monthMod = getFormatYmToLongTitle(this.month);
		}

		// Разделяем массив на 4 части по 7 элементов
		this.weeks = this.onSplitArray(this.calendarData, 7);

		this.modName = this.name;

		this.logoMod.url = getAppUrl + this.profileImage;
		this.logoMod.value = getAppUrl + this.profileImage;

		if (Array.isArray(this.month_info) && this.month_info.length > 0) {
			this.updateMonthInfo(this.month_info[0]);
		}
	},

	watch: {
		calendarData(val, oldVal) {
			if (val !== oldVal) {
				this.weeks = this.onSplitArray(this.calendarData, 7);
			}
		},

		overtime(val, oldVal) {
			if (val !== oldVal) {
				this.overtimeData = this.getTimeMoment(this.overtime);

			}
		},
		total_schedule_time(val, oldVal) {
			if (val !== oldVal) {
				this.allTime = val;
				this.allTimeMod = this.getTimeMoment(val);
				this.timeLeft = this.calculateTimeDifference(this.allTime, this.workTime);
			}
		},
		total_work_time(val, oldVal) {
			if (val !== oldVal) {
				this.workTime = val;
				this.workTimeMod = this.getTimeMoment(val);
				this.timeLeft = this.calculateTimeDifference(this.allTime, this.workTime);
			}
		},
		month_info(val, oldVal) {
			if (val !== oldVal) {
				if (val && val.length > 0) {
					this.updateMonthInfo(val[0]);
				}
			}
		},
		'userData.month': {
			immediate: true,
			handler(v) {
				if (v === undefined || v === null) {
					this.isMonthLocal = null; return;
				}
				this.isMonthLocal = (v === true || v === 1 || v === '1' || v === 'true');
			},
		},
	},
};

</script>

<style lang="scss">
@import "accountTabHomeGlobal";
</style>
<style scoped lang="scss">
@import "accountTabHome";
</style>

<style scoped lang="scss">
.photo .photoWrap .iconCompany {
	background: rgba(76, 76, 76, 0.58);
	padding: 2px;
	border-radius: 3px;
	position: absolute;
	top: 8px;
	left: 8px;
	display: block;

	svg {
		display: block;
		width: 100%;
		height: 100%;
	}
}

.workTableHead {
	position: relative;
	.cauldronWrap {
		position: absolute;
		top: -38px;
		right: 140px;
		cursor: none;
		.cauldron {
			position: relative;
			z-index: 10;
		}
		.zombie-horror {
			position: absolute;
			z-index: 1;
			left: 4px;
			top: 0;
			opacity: 0;
			visibility: hidden;
			transition: 0.3s;
		}
		&:hover {
			.zombie-horror {
				top: -19px;
				opacity: 1;
				visibility: visible;
			}
		}
	}

}

.workTableMain.halloween {
	//position: relative;
	///* Striped background */
	background: #2b2b37;
	background-image:
			linear-gradient(90deg, transparent 50%, #2b2b37 50%);
	background-size: 52px;
	box-shadow: inset 0 0 100px #000;
	//
	//text-align: center;
	//padding: 2em 2em 3em;
	position: relative;
	overflow: hidden;

	.rowLine {
		position: static;
	}
	&::before,
	&::after {
		content: '';
		display: block;
		width: 100%;
		position: absolute;
		left: 0;
	}

	&::before {
		/* Red gradients for blood */

		/* Background blend for bleed effect */
		mix-blend-mode: multiply;

		/* Mouse ignore blood */
		pointer-events: none;

		/* Hide before hover transition */
		opacity: 0;
		transform: translateY(-100%);

		/* Mouseout effect */
		transition: opacity 3s linear, transform 1s 3s linear;

		width: 100%;
		height: 220px;
		position: absolute;
		left: 0;
		top: 0;
		background: linear-gradient(red 50%, transparent 60%), radial-gradient(#d40000 50%, rgba(0, 0, 0, 0) 70%), radial-gradient(#ff0000 30%, rgba(0, 0, 0, 0) 40%), radial-gradient(#d40000 10%, rgba(0, 0, 0, 0) 20%), radial-gradient(#ff0000 10%, rgba(0, 0, 0, 0) 15%);
		background-size: 100% 100%, 500px 500px, 200px 200px, 103px 273px, 77px 800px;
		background-position: 0 0, -97% -78%, 71% 0%, 7% 23%, 5% 49%;
		mix-blend-mode: multiply;
		pointer-events: none;
		transform: translateY(-100%);
		xtransition: opacity 3s linear, transform 1s 3s linear;
	}

	/* Hover transition */
	&:hover::before {
		opacity: 0.7;
		transform: translateY(0);
		transition: opacity 1s 0s, transform 5s 0s linear;
	}
}

</style>
